<template>
  <div class="social-networks-connections">

    <div v-if="data" class="connection-list">
      <div v-for="item in data"
           :key="item.key"
           class="connection-list__item">

        <div class="connection-list__item-logo">
          <img :src="logos[item.key]" :alt="titles[item.key]">
        </div>

        <div class="connection-list__item-title">{{titles[item.key]}}</div>
        <div v-if="item.status === 0" class="connection-list__item-button">
          <button type="button"
                  @click="connectTo(item.key)"
                  class="base-btn base-btn--blue base-btn--small">
            <span class="base-btn__text">{{$tSettings('Connect')}}</span>
          </button>
        </div>

        <div v-else class="connection-list__item-button">
          <button type="button"
                  @click="deleteConnection(item.key)"
                  class="base-btn base-btn--outline-dark base-btn--small">
            <span class="base-btn__text">{{$tSettings('Disable')}}</span>
          </button>
          <div class="subtext">{{$tSettings('Connected')}}</div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
  import axios from 'axios'
  import {mapState} from 'vuex'

  import FB from '../assets/img/account-settings/FB.png'
  import VK from '../assets/img/account-settings/VK.png'
  import OK from '../assets/img/account-settings/OK.png'
  import Instagram from '../assets/img/account-settings/Instagram.png'
  import Linkedin from '../assets/img/account-settings/Linkedin.png'
  import Youtube from '../assets/img/account-settings/Youtube.png'

  export default {
      name: "SocialNetworksConnections",
      props: {
        data: {
          type: Object
        }
      },
      data() {
        return {
          logos: {
            FB,
            VK,
            OK,
            Instagram,
            Linkedin,
            Youtube
          },
          titles: {
            FB: 'Facebook',
            VK:  'Vkontakte',
            OK: 'Odnoklassniki',
            Instagram: 'Instagram',
            Linkedin: 'Linkedin',
            Youtube: 'Youtube'
          }
        }
      },
      computed: {
        ...mapState(['aiToken']),
        ...mapState('user', ['profile']),
      },
      methods: {
        connectTo(key) {
          window.location = `https://jobian-ai.whiteweb.com.ua/${this.profile.id}/${key}`
        },
        deleteConnection(key) {
          if(this.aiToken) {
            axios.post(`https://jobian-ai.whiteweb.com.ua/api/v1/front/delete?user=${this.profile.id}&social=${key}`, {}, {headers: {Authorization: 'Bearer ' + this.aiToken}})
              .then((data) => {
                return data
              })
              .catch((error) => {if(error) {console.log(error)}})
              .finally(()=>{this.update()})
          }
        },
        update() {
          return this.$emit('update')
        }
      }

  }
</script>

<style scoped>

</style>
